import { render, staticRenderFns } from "./EmailsNewView.vue?vue&type=template&id=0801b7a7&scoped=true"
import script from "./EmailsNewView.vue?vue&type=script&lang=js"
export * from "./EmailsNewView.vue?vue&type=script&lang=js"
import style0 from "./EmailsNewView.vue?vue&type=style&index=0&id=0801b7a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0801b7a7",
  null
  
)

export default component.exports